<template>
  <div class="animated fadeIn">
    <b-row>
      <b-col xl="12">
        <b-form>
          <b-card header= "Ultimo Comprobante Autorizado">
            <app-comprobante-tipo
              label="Tipo de Comprobante"
              :label-cols="labelCols"
              :nombre="afipComprobanteTipoNombreUC"
              :valido="afipComprobanteTipoValido"
              :lista="afipComprobantesTiposList"
              :msjInvalido="afipComprobanteTipoInvalidoMsj"
              :nullDisabled="true"
              @validate="validate"
              @updated="afipComprobanteTipoActualizado">
            </app-comprobante-tipo>  

            <b-form-group
              label="Punto de Venta"
              label-for="numeroPuntoVentaUC"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroPuntoVentaUC"
                v-model.trim="$v.numeroPuntoVentaUC.$model" 
                :state="numeroPuntoVentaUCValido"
                type="text"
                @blur.native="validate">
              </b-form-input>
              <b-form-invalid-feedback id="numeroPuntoVentaUCFeedback">
                {{ numeroPuntoVentaUCInvalidoMsj }}
              </b-form-invalid-feedback>          
            </b-form-group>

            <b-form-group
              label="Nro Comprobante"
              label-for="numeroUC"
              :label-cols="labelCols"
              horizontal>
              <b-form-input 
                id="numeroUC"
                :value="numeroUC"
                readonly>
              </b-form-input>
            </b-form-group>

            <div slot="footer">
              <b-button size="sm" variant="primary" class="footer-button" 
                @click.prevent="getUltimoAutorizado">Consultar</b-button>
            </div>
          </b-card>
        </b-form>
      </b-col>
    </b-row>
    
    <app-mensaje
      :modalMsj="modalMsj"
      :modalMensaje="modalMensaje"
      @okAction="okAction"
      @hiddenAction="hiddenAction">
    </app-mensaje>
  </div>
</template>

<script>
import ComprobanteTipo from '../shared/abmSelect.vue';
import Mensaje from  '../shared/msjModal.vue';
import { msjModal } from '../../mixins/modalDialogs';
import { required, numeric, minValue } from 'vuelidate/lib/validators';

import { createHelpers } from 'vuex-map-fields';
const { mapFields } = createHelpers({
  getterType: 'facturaelectronica/getField',
  mutationType: 'facturaelectronica/updateField',
});

export default {
  name: 'ParametrosFacturaElectronica',
  components: {
    appComprobanteTipo: ComprobanteTipo,
    appMensaje: Mensaje,
  },
  mixins: [ 
    msjModal, 
  ],
  data () {
    return {
      noValidar: true,
      afipComprobanteTipoValido: null,
      afipComprobanteTipoInvalidoMsj: '',
      numeroPuntoVentaUCValido: null,
      numeroPuntoVentaUCInvalidoMsj: '',

      labelCols: 2,
    }
  },
  computed: {
    ...mapFields([
      'datosUltimoComprobante',
      'afipComprobantesTipos',
      'afipComprobantesTiposList',
      'afipComprobanteTipoUC',
      'afipComprobanteTipoNombreUC',
      'numeroPuntoVentaUC',
      'numeroUC'
    ]),
  },  
  created() {
    this.numeroUC = 0;
  },
  methods: {
    validate(event) {
      if (event) {
        if (event.target) {
          /* Antes de intentar registrar por primera vez, no validamos */
          if (!this.noValidar){
            this.$v.$touch();
            this.displayErrores(event.target.id);
          }
        }
      } 
    },
    displayErrores(field) {
      var validarTodos = false;
      var campo = '';

      if (field) {
        campo = field;
      } else {
        validarTodos = true;
      }

      if (campo == 'numeroPuntoVentaUC' || validarTodos) {
        if (this.$v.numeroPuntoVentaUC.$error) {
          this.numeroPuntoVentaUCValido = false;
          if (!this.$v.numeroPuntoVentaUC.required) {
            this.numeroPuntoVentaUCInvalidoMsj = 'Debe ingresar el número de punto de venta a consultar.';
          } else if (!this.$v.numeroPuntoVentaUC.numeric) {
            this.numeroPuntoVentaUCInvalidoMsj = 'El número de punto de venta debe ser un valor numérico';
          } else if (!this.$v.numeroPuntoVentaUC.minValue) {
            this.numeroPuntoVentaUCInvalidoMsj = 'El número de punto de venta debe ser un valor numérico positivo.';
          }     
        } else {
          this.numeroPuntoVentaUCValido = null;
          this.numeroPuntoVentaUCInvalidoMsj = '';
        }
      }
    },
    getUltimoAutorizado () {
      /* Antes de intentar registrar por primera vez, no validamos */
      this.noValidar = false;

      var afipComprobanteTipoUC = null;
      if (this.afipComprobanteTipoNombreUC) {
        afipComprobanteTipoUC = this.getSelected(this.afipComprobantesTipos, this.afipComprobanteTipoNombreUC);
      }
      this.$store.dispatch('facturaelectronica/setAfipComprobanteTipoUC', afipComprobanteTipoUC);

      this.$v.$touch();

      if (this.$v.$anyError) {
        this.displayErrores();
      } else {

        this.showSpinner();
        this.$store.dispatch('facturaelectronica/getUltimoAutorizado')
          .then(() => {
            if (this.datosUltimoComprobante.errores) {
              this.datosUltimoComprobante.errores.forEach(error => {
                this.showErrorMsj (error.descripcion);
              });
            }
          })
          .catch( error => this.showErrorMsj (error))
          .finally(() => this.hideSpinner() )
      }
    },
    afipComprobanteTipoActualizado(nombre) {
      this.afipComprobanteTipoNombreUC = nombre;
      
      if (this.afipComprobanteTipoNombreUC) {
        this.afipComprobanteTipoValido = null;
        this.afipComprobanteTipoInvalidoMsj = '';
      }
    },
  },
  validations: {
    numeroPuntoVentaUC: {
      required,
      numeric,
      minValue: minValue(0),
    },
  },  
}
</script>

<style>
</style>
